import { glassMixin, darkGlassMixin } from "../../styles";

export const theme = {
  dark: {
    headingColor: "#FFFFFF",
    headingCountColor: "#888888",
    seeAllBorder: "rgba(255,255,255,0.3)",
    seeAllColor: "#FFFFFF",
    seeAllHover: "rgba(255,255,255,0.08)",
    watchButtonBg: "#FFFFFF",
    watchButtonColor: "#0B0B0B",
    watchButtonHover: "rgba(255,255,255,0.75)",
    cardBg: "#1E2025",
    cardText: "#FFFFFF",
    cardTextAlt: "#B0B0B0",
    cardSeparator: "#4B4D51",
    mobileCardBg: "#1E2025",
    mobileCardTitleColor: "#FFFFFF",
    mobileModalBg: "#1a1a1a",
    mobileModalColor: "#FFFFFF",
    mobileModalSubText: "#B0B0B0",
    mobileModalGenreBorder: "rgba(255,255,255,0.25)",
    mobileModalGenreColor: "#DDDDDD",
    modalBg: "#111111",
    modalColor: "#FFFFFF",
    modalSubText: "#888888",
    borderContrast: "#FFFFFF",
    glassMixin: darkGlassMixin,
  },
  light: {
    headingColor: "#121419",
    headingCountColor: "grey",
    seeAllBorder: "#0B0B0B",
    seeAllColor: "#121419",
    seeAllHover: "rgba(0,0,0,0.05)",
    watchButtonBg: "#0B0B0B",
    watchButtonColor: "#FFFFFF",
    watchButtonHover: "rgb(60,60,60,1)",
    cardBg: "#ffffff",
    cardText: "#121419",
    cardTextAlt: "#555555",
    cardSeparator: "#cccccc",
    mobileCardBg: "#ffffff",
    mobileCardTitleColor: "#121419",
    mobileModalBg: "#ffffff",
    mobileModalColor: "#222222",
    mobileModalSubText: "#555555",
    mobileModalGenreBorder: "#cccccc",
    mobileModalGenreColor: "#333333",
    modalBg: "#ffffff",
    modalColor: "#121419",
    modalSubText: "grey",
    borderContrast: "#000000",
    glassMixin: glassMixin,
  }
};

export const colors = {
  background: {
    white: "#ffffff",
    black: "#0B0B0B",
    lightBlack: "#121419",
    formField: "#1E2025",
    grey: "#4B4D51",
    shadowSmoke:"#dddddd",
    mediumGray: "#888888",
    lightGrey: "#1d1f24",
    scrollListBg: "#1E2025",
    scrollButtonBg: "#B7F84D",
    hoverGrey: "rgb(184, 180, 180)",
    hoverLight: "rgba(0, 0, 0, 0.05)",
    black60:" rgba(0, 0, 0, 0.6)",
    halfBlack:"rgba(0, 0, 0, 0.5)",
    transparentBlack:"rgba(0, 0, 0, 0.3)",
    dray80: "#ccc",
    drakBlue: "#00000042"
  },
  text: {
    white: "#FFFFFF",
    black: "#121419",
    gray: "#B0B0B0",
    lightGray:"#9F9F9F99"
  },
  border: {
    scrollButton: "#48602A",
    black: "#0B0B0B",
  },
  shadow: {
    cardLight :"0 4px 12px rgba(0, 0, 0, 0.15)",
    card: "0 4px 12px rgba(0, 0, 0, 0.2)",
    hoverOverlay: "0 8px 20px rgba(0, 0, 0, 0.3)",
    frostedWhite: "rgba(255, 255, 255, 0.4)",
  } 
};
